import Default from 'umg-ember-backend/components/record-detail/for/default';

<template><Default @model={{@model}} /></template>
